import {
  DashboardMenuItem,
  Menu
} from 'react-admin';

import CustomerPassportPhysicalIcon from "@mui/icons-material/PendingActions";

const CustomMenu = () =>
{
  return (
    <Menu>
      <DashboardMenuItem />
      <Menu.Item
        key={'Passaporte Físico'}
        to={'/customer-passport-physical'}
        primaryText={'Passaporte Físico'}
        leftIcon={<CustomerPassportPhysicalIcon />}
      />
    </Menu>
  );
};

export default CustomMenu;
